import { ActivityTable } from '@/components/activity/ActivityTable';

import { SAMPLE_ACTIVITY } from '../sampleData';
import { State } from '../State';

export function ActivityTableExamples() {
  return (
    <State
      title="The audit log over two sample entries"
      note="The fetchers here resolve local data, so filtering and paging send nothing."
    >
      <ActivityTable
        view="gallery"
        testId="gallery-activity"
        fetchEntries={() =>
          Promise.resolve({ items: SAMPLE_ACTIVITY, total: SAMPLE_ACTIVITY.length })
        }
        fetchActors={() => Promise.resolve([SAMPLE_ACTIVITY[0].actor])}
        showOrganization
      />
    </State>
  );
}
